import React from "react";
import classnames from "classnames";
import isEqual from "lodash/isEqual";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
//icons
import ActionPrint from "@material-ui/icons/Print";
// jazasoft
import { PageHeader, PageFooter, BackButton, showNotification } from "jazasoft";
// local
import OrderDetails from "../../OrderDetails";
import MicroController from "./MicroController";
//helpers
import { printGarmentRecuttingReport, getData, DataType } from "../../feedback/feedbackHelper";
import { DEFAULT_SEPARATOR, MicroReportId } from "../../../constants";
import { OState } from "../../../utils/types";

const styles = theme => ({
  root: {},
  container: {
    margin: "1.5em",
    padding: 0
  },
  marginVertical: {
    margin: "1.5em 0"
  },
  displayCenter: {
    display: "flex",
    justifyContent: "center",
    margin: "1.5em"
  }
});

class GarmentRecuttingReportView extends React.Component {
  state = {
    busy: false
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.order, nextProps.order)) {
      const order = nextProps.order;
      const fabricIds =
        order && order.flowInfoList.flatMap(part => part.ledgerList || []).map(ledger => ledger.fabricId);
      this.props.updateFabricsDeep(fabricIds);
    }
  }

  onPrint = orderFlow => () => {
    this.setState({ busy: true });
    const { order, fabrics } = this.props;
    if (orderFlow.stateValue >= OState.REMNANT_FEEDBACK_COMPLETED.stateValue) {
      this.props.fetchLaySlip(orderFlow, (layslip, err) => {
        if (layslip) {
          const rowsCutSummary = getData({
            dataType: DataType.GARMENT_RECUT_SUMMARY,
            order,
            orderFlow,
            layMap: layslip,
            styleColor: orderFlow.styleColor
          });
          const rows = getData({
            dataType: DataType.GARMENT_RECUT_ROLL,
            order,
            orderFlow,
            fabrics,
            styleColor: orderFlow.styleColor
          });
          let rowsRoll = rows.map((roll, idx) => ({ ...roll, serialNo: idx + 1 }));
          let rowTotal = ["length", "available", "reCutGarment"].reduce(
            (acc, key) => ({
              ...acc,
              [key]: rowsRoll.reduce((acc, roll) => acc + parseFloat(roll[key]), 0).toFixed(2)
            }),
            {}
          );
          rowsRoll.push({ ...rowTotal, shade: "Total" });

          printGarmentRecuttingReport({
            order,
            orderFlow,
            color: orderFlow.color,
            rowsCutSummary,
            rowsRoll,
            layMap: layslip
          });
        } else {
          console.log(err);
        }
        this.setState({ busy: false });
      });
    } else {
      this.props.dispatch(showNotification("Laying not completed yet."));
    }
  };

  render() {
    const { classes, order, basePath, i18nKey, resource, orderFlowMap } = this.props;

    const orderFlowList = orderFlowMap ? Object.keys(orderFlowMap).map(key => orderFlowMap[key]) : [];

    return (
      <div className={classnames(classes.root)}>
        <PageHeader title="Garment Recutting Report" />

        {order && Object.keys(order).length > 0 && (
          <div id="container" className={classes.container}>
            {/*Order Details */}
            <OrderDetails
              id="order-details"
              className={classes.border}
              record={order}
              basePath={basePath}
              resource={resource}
              i18nKey={i18nKey}
            />

            {orderFlowList.length > 0 && (
              <Paper className={classes.marginVertical} square>
                <List>
                  {orderFlowList
                    .flatMap(of =>
                      of.styleColorList
                        .sort((a, b) => (a < b ? -1 : 1))
                        .map(styleColor => ({
                          ...of,
                          styleColor,
                          style: styleColor?.split(DEFAULT_SEPARATOR)[0],
                          color: styleColor?.split(DEFAULT_SEPARATOR)[1]
                        }))
                    )
                    .map((of, idx) => (
                      <ListItem key={idx}>
                        <ListItemText>{`${of.product?.name}, ${of.style}, ${of.color}, ${of.part}, Lot${of.lot}`}</ListItemText>
                        <ListItemSecondaryAction>
                          <Button
                            edge="end"
                            aria-label="Print"
                            color="primary"
                            onClick={!this.state.busy ? this.onPrint(of) : null}>
                            <ActionPrint style={{ marginRight: 4 }} />
                            Print
                          </Button>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                </List>
              </Paper>
            )}

            {orderFlowList.length === 0 && (
              <div className={classes.displayCenter}>
                <Typography color="secondary" variant="h6">
                  Report not available
                </Typography>
              </div>
            )}

            <PageFooter>
              <BackButton variant="contained" color="default" />
            </PageFooter>
          </div>
        )}
      </div>
    );
  }
}

const StyledGarmentRecuttingReport = withStyles(styles)(GarmentRecuttingReportView);

const GarmentRecuttingReport = props => (
  <MicroController microReportId={MicroReportId.GARMENT_RECUTTING} {...props}>
    {controllerProps => <StyledGarmentRecuttingReport {...props} {...controllerProps} />}
  </MicroController>
);

export default GarmentRecuttingReport;
